import React from "react"
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"
import styles from "./styles"

import Image from "../Icons/Image"

const ImageLoading = ({ classes }) => (
    <div className={classes.container}>
        <div className={classes.background} />
        <Image className={classes.placeholder} />
    </div>
)

ImageLoading.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(ImageLoading)



// WEBPACK FOOTER //
// ./src/lib/components/ImageLoading/index.js